import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import Store from 'lightningjs-redux';
import { HOME_ALIAS } from '@bedrock-rdk/constants';
import { LAYOUT_ALIASES } from '@bedrock/fido-sdk';
import { createItemAction } from '../cta/cta.actions';
import { createLayoutAction } from '../layout/abstractLayout.utils';
import { getInitialStyle } from './exploreCatalogue.style';
import { Button } from '../tornado/button/button.component';
import { t } from '../i18n';

export class ExploreCatalogue extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Background: {
          rect: true,
        },
        Content: {
          MainTitle: {
            text: {
              text: t('bookmarks.title'),
            },
          },
          Blocks: {},
          Title: {
            text: {
              text: t('bookmarks.noContentTitle'),
            },
          },
          Description: {
            text: {
              text: t('bookmarks.noContentDescription'),
            },
          },
          Button: {
            type: Button,
            label: t('bookmarks.noContentAction'),
          },
        },
      },
      getInitialStyle(),
    );
  }

  _getFocused() {
    return this.tag('Button');
  }

  _handleEnter() {
    return Store.dispatch(createItemAction(createLayoutAction(HOME_ALIAS, LAYOUT_ALIASES, 'pressBookmarksButton')));
  }
}
